import React from 'react';
import NumberField from '../../../features/diagnostic/components/NumberField';
import { getDealModel } from '../../../data/diagnostic/dealModels';
import { formatMoney, formatNumber, formatPercent } from '../../../features/diagnostic/format';

const isEmpty = (value) => value === '' || value === null || value === undefined;

const StepNumbers = ({ niche, state, result, setField, showValidation = false }) => {
  const dealModel = getDealModel(state.dealModelId);
  const keyMetric = niche ? niche.keyMetric : null;
  const optionalMetric = niche ? niche.optionalMetric : null;
  const frequencyIsKeyMetric = keyMetric && keyMetric.id === 'visitFrequency';

  const isValid = result && result.valid;
  const revenueInvalid = showValidation && isEmpty(state.revenue);
  const salesInvalid = showValidation && isEmpty(state.sales);

  return (
    <div className="dg-step">
      <h2 className="dg-step-title">Ваши цифры за последний месяц</h2>
      <p className="dg-step-lead">
        Достаточно того, что вы знаете примерно. Если цифра неточная — результат всё равно покажет,
        где ваш главный резерв.
      </p>

      <div className="dg-fields">
        <NumberField
          label="Выручка за месяц"
          suffix="₸"
          value={state.revenue}
          onChange={(value) => setField('revenue', value)}
          placeholder="например 3000000"
          min={0}
          invalid={revenueInvalid}
          errorMessage="Укажите выручку за месяц"
        />

        <NumberField
          label="Сколько было продаж за месяц"
          suffix="шт"
          hint="Число оплат или чеков, а не число клиентов"
          value={state.sales}
          onChange={(value) => setField('sales', value)}
          placeholder="например 600"
          min={0}
          invalid={salesInvalid}
          errorMessage="Укажите число продаж"
        />

        <NumberField
          label="Сколько человек к вам обратилось за месяц"
          suffix="чел"
          hint="Заявки, звонки, сообщения, визиты. Без этой цифры не увидим, где теряются клиенты"
          value={state.leads}
          onChange={(value) => setField('leads', value)}
          placeholder="например 900"
          optional
          min={0}
        />

        {keyMetric ? (
          <NumberField
            label={keyMetric.label}
            suffix={keyMetric.unit}
            hint={keyMetric.hint}
            value={state.keyMetric}
            onChange={(value) => setField('keyMetric', value)}
            min={keyMetric.min}
            max={keyMetric.max}
            step="any"
          />
        ) : null}

        {!frequencyIsKeyMetric ? (
          <NumberField
            label="Сколько раз в месяц покупает один клиент"
            suffix="раз"
            hint={`Если не знаете — оставьте пустым, посчитаем по модели «${dealModel.label.toLowerCase()}»`}
            value={state.frequency}
            onChange={(value) => setField('frequency', value)}
            optional
            min={0}
            step="any"
          />
        ) : null}

        {optionalMetric ? (
          <NumberField
            label={optionalMetric.label}
            suffix={optionalMetric.unit}
            hint={optionalMetric.hint}
            value={state.optionalMetric}
            onChange={(value) => setField('optionalMetric', value)}
            optional
            step="any"
          />
        ) : null}

        <NumberField
          label="Рекламный бюджет за месяц"
          suffix="₸"
          hint="Если рекламу не даёте — оставьте пустым"
          value={state.adBudget}
          onChange={(value) => setField('adBudget', value)}
          optional
          min={0}
        />
      </div>

      {isValid ? (
        <div className="dg-preview">
          <div className="dg-preview-title">Уже видно из ваших цифр</div>
          <div className="dg-preview-grid">
            <div className="dg-preview-item">
              <span className="dg-preview-label">Средний чек</span>
              <span className="dg-preview-value">{formatMoney(result.state.averageCheck)}</span>
            </div>
            <div className="dg-preview-item">
              <span className="dg-preview-label">Клиентов за месяц</span>
              <span className="dg-preview-value">{formatNumber(result.state.clients)}</span>
            </div>
            {result.state.hasConversion ? (
              <div className="dg-preview-item">
                <span className="dg-preview-label">Доходит до покупки</span>
                <span className="dg-preview-value">
                  {formatPercent(result.state.conversionPercent, 1)}
                </span>
              </div>
            ) : null}
            {result.adMetrics && result.adMetrics.costPerClient ? (
              <div className="dg-preview-item">
                <span className="dg-preview-label">Один клиент обходится</span>
                <span className="dg-preview-value">
                  {formatMoney(result.adMetrics.costPerClient)}
                </span>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}

      {result && result.warnings && result.warnings.length ? (
        <div className="dg-warnings">
          {result.warnings.map((warning) => (
            <p key={warning.code} className="dg-warning">
              {warning.text}
            </p>
          ))}
        </div>
      ) : null}

      {result && !result.valid && result.errors ? (
        <div className="dg-warnings">
          {result.errors.map((error) => (
            <p key={error.code} className="dg-warning dg-warning--error">
              {error.text}
            </p>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default StepNumbers;
